import styled from 'styled-components'

export const Container = styled.section`
  width: 100%;
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
`

export const Logo = styled.div`
  img {
    width: 348px;
  }

  @media screen and (min-width: 961px) {
    margin-bottom: 20px;

    img {
      width: 448px;
    }
  }
`

export const Card = styled.div`
  width: 98%;
  max-width: 450px;
  background: var(--color-white);
  border-radius: 30px;
  padding: 30px 25px;
  justify-content: center;
  align-items: stretch;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 961px) {
    padding: 40px 60px;
  }
`

export const Title = styled.h1`
  font-size: 22px;
  line-height: 28px;
  font-weight: 600;
  color: var(--color-black);
  margin-bottom: 8px;
  text-align: center;
`

export const Subtitle = styled.p`
  font-size: 14px !important;
  color: var(--color-gray-50);
  text-align: center;
  margin-bottom: 24px;
`

export const StepIndicator = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
`

export const StepDot = styled.span<{ active: boolean }>`
  width: 28px;
  height: 4px;
  border-radius: 2px;
  background: ${({ active }) =>
    active ? 'var(--color-secondary)' : '#e0e0e0'};
  transition: background 0.3s;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const AreaButton = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const BackLink = styled.button`
  background: transparent;
  border: none;
  color: var(--color-secondary);
  font-size: 14px;
  cursor: pointer;
  margin-top: 12px;
  text-align: center;

  &:hover {
    text-decoration: underline;
  }
`
